import * as React from "react";

import { InputContainer, InputContainerProps } from "./input-container";

export interface CheckboxInputProps extends InputContainerProps {
  id: string;

  onChange: (name: string, value: boolean) => void;
}

export const CheckboxInput: React.FunctionComponent<CheckboxInputProps> = (
  props
) => {
  const isChecked = !!props.form[props.name];
  return (
    <InputContainer {...props} className="checkbox-input">
      <div className={`input-immediate-container ${isChecked ? "checked" : "unchecked"}`}>
        <input
          type="checkbox"
          id={props.id}
          name={props.name}
          checked={isChecked}
          onChange={(event) => props.onChange(props.name, event.target.checked)}
        />
        <label htmlFor={props.id} className="name">
          {props.children}
        </label>
      </div>
    </InputContainer>
  );
};
